import { Variable, VariableSummary } from '@mtna/pojo-consumer-ui';

import { RdsNullFilter } from './null-filter.model';

export class BaseFilter<V extends Variable | VariableSummary = Variable> {
  constructor(public variable: V, public nullFilter?: RdsNullFilter) {}
}
